import { useMemo, useState } from "react";
import { usePageableTable } from "../../../context/PageableTableContext";
import {
  mapFiltersToQueryString,
  storeLastFiltersAndResults,
} from "../../../helpers";
import { retrieveObjectFromLocalStorage } from "../../../helpers/local-storage.helper";
import { Predicates } from "../../../libraries/predicates/predicates";
import { PageableTableActions } from "../../../states/pageable-table";
import {
  ARTWORK_COLLECTION_PREFIX,
  ARTWORK_PRINTING_TECHNIQUE_PREFIX,
  ArtworkCollectionPersistentData,
  META_ARTWORK_PREFIX,
} from "../../../types/persistent-page-filters";
import SearchFilters from "../components/search/SearchFilters";
import ArtworkTable from "./ArtworkTable";
import { useArtworkSearchesStore } from "../../../context/ArtworkSearchesContext";
import { useMetaArtworkSearchStore } from "../../../context/MetaArtworkSearchContext";

const Search = () => {

  const { state, dispatch} = useMetaArtworkSearchStore()

  const prefix = useMemo(() => {
    return state.artworkLevel === "collection"
      ? ARTWORK_COLLECTION_PREFIX
      : state.artworkLevel === "meta-artwork"
        ? META_ARTWORK_PREFIX
        : ARTWORK_PRINTING_TECHNIQUE_PREFIX;
  }, [state.artworkLevel]);

  const lastFilter =
    retrieveObjectFromLocalStorage<ArtworkCollectionPersistentData>(
      prefix,
      "lastFilters",
    );
  const lastQueryString = Predicates.isNotNullAndNotUndefined(lastFilter)
    ? mapFiltersToQueryString(lastFilter)
    : "";

  const [queryString, setQueryString] = useState(lastQueryString);

  const {
    state: { total, isFirstRender },
    dispatch:dispatchPagableTable,
  } = usePageableTable();

  const filterProducts = (filters: any, dropdownFiltersToStore: any, prefix:any) => {
    storeLastFiltersAndResults(
      filters,
      dropdownFiltersToStore,
      prefix,
    );
    setQueryString(mapFiltersToQueryString(filters));
    if (isFirstRender) dispatchPagableTable(PageableTableActions.setFirstRender(false));
  };


  return (
    <>
      <div className="card shadow-sm mb-2 mt-1">
        <div className="card-body p-1">
          <SearchFilters
            prefix={prefix}
            filterProducts={filterProducts}
          />
        </div>
      </div>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 text-primary">
          </h6>
        </div>
        <div className="card-body">
          <ArtworkTable
            localStoragePrefix={prefix}
            filters={{ queryString }}
          />
        </div>
      </div>
    </>
  );
};

export default Search;
